import script from "./ConsultButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultButton.vue?vue&type=script&setup=true&lang=js"

import "./ConsultButton.vue?vue&type=style&index=0&id=75156dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75156dea"]])

export default __exports__